import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Redirect-only sibling of `/quote/confirm/$orderCode` (file-based spike).
 * An `index.tsx` next to `$orderCode.tsx` keeps both routes siblings under the
 * implicit `/quote/confirm` node — a `confirm.tsx` layout would run this
 * redirect loader on the child route too.
 */
export const Route = createFileRoute("/quote/confirm/")({
  loader: () => {
    throw redirect({ href: "/quote" });
  },
});
